import { useTranslation } from 'react-i18next';

export default function CourseOverview() {
  const { t } = useTranslation();

  const rowKeys = [
    { key: 'rowDuration', valueKey: 'duration', accent: false },
    { key: 'rowHours', valueKey: 'totalHours', accent: false },
    { key: 'rowPrice', valueKey: 'price', accent: true },
    { key: 'rowSchedule', valueKey: 'schedule', accent: false },
    { key: 'rowFormat', valueKey: 'classFormat', accent: false },
    { key: 'rowCapacity', valueKey: 'capacity', accent: false },
    { key: 'rowTarget', valueKey: 'target', accent: false },
  ] as const;

  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-12">
          {String(t('coursesEssential.overview.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesEssential.overview.title')}
          </h2>
          <div className="gold-line mx-auto"></div>
        </div>

        {/* Table */}
        <div className="table-scroll overflow-hidden border border-background-200/80">
          <div className="overflow-x-auto">
            <table className="w-full sm:min-w-[600px]">
              <thead>
                <tr className="bg-primary-900">
                  <th className="w-[110px] sm:w-[180px] px-4 sm:px-6 py-4 text-left text-[14px] text-accent-400 tracking-[0.1em] font-medium font-heading">
                    {t('coursesEssential.overview.colItem')}
                  </th>
                  <th className="px-4 sm:px-6 py-4 text-left text-[14px] text-accent-400 tracking-[0.1em] font-medium font-heading">
                    {t('coursesEssential.overview.colContent')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {rowKeys.map(({ key, valueKey, accent }, index) => (
                  <tr
                    key={index}
                    className={`border-t border-background-200/60 ${
                      index % 2 === 0 ? 'bg-background-100/50' : 'bg-background-50'
                    }`}
                  >
                    <td className="px-4 sm:px-6 py-4 text-[15px] text-foreground-500 tracking-[0.06em] font-label whitespace-nowrap">
                      {t(`coursesEssential.overview.${key}`)}
                    </td>
                    <td className={`px-4 sm:px-6 py-4 text-[16px] tracking-[0.04em] break-words ${
                      accent ? 'text-accent-700 font-medium' : 'text-foreground-800'
                    }`}>
                      {valueKey === 'price'
                        ? t('coursesEssential.overview.priceFormat').replace('{price}', t(`coursesEssential.overview.${valueKey}`))
                        : t(`coursesEssential.overview.${valueKey}`)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Note */}
        <p className="text-[13px] text-foreground-500 tracking-[0.04em] mt-5 text-center">
          {t('coursesEssential.overview.note')}
          <a href="/schedule" className="text-accent-600 hover:text-accent-500 underline underline-offset-2 transition-colors">
            {t('coursesEssential.overview.scheduleLink')}
          </a>
          {t('coursesEssential.overview.noteSuffix')}
        </p>
      </div>
    </section>
  );
}